<script setup lang="ts">
import type { PageFeatureProps } from '#ui/types';

// COMPOSABLES
const { isMobile } = useResponsive();
const { tt } = useTypedI18n();
const { busAssets } = useFleequidStats();

// DATA
const features = computed<PageFeatureProps[]>(() => [
    {
        title: tt('sdp.auctionInfoModal.item1.title'),
        description: tt('sdp.auctionInfoModal.item1.description'),
        icon: 'lucide:landmark',
    },
    {
        title: tt('sdp.auctionInfoModal.item2.title'),
        description: tt('sdp.auctionInfoModal.item2.description', { count: busAssets.value }),
        icon: 'lucide:shield-check',
        ui: { leadingIcon: 'text-success' },
    },
    {
        title: tt('sdp.auctionInfoModal.item3.title'),
        description: tt('sdp.auctionInfoModal.item3.description'),
        icon: 'lucide:tag',
    },
    {
        title: tt('sdp.auctionInfoModal.item4.title'),
        description: tt('sdp.auctionInfoModal.item4.description'),
        icon: 'lucide:timer',
    },
    {
        title: tt('sdp.auctionInfoModal.item5.title'),
        description: tt('sdp.auctionInfoModal.item5.description'),
        icon: 'lucide:credit-card',
        ui: { leadingIcon: 'text-warning' },
    },
]);
</script>

<template>
    <UModal :fullscreen="isMobile" :title="tt('sdp.auctionInfoModal.title')" :ui="{ content: 'max-w-3xl' }" v-bind="modalNoDescAriaFixupProps">
        <UButton class="p-0" color="neutral" variant="ghost" size="xs" @click.stop.prevent>
            <UIcon name="lucide:info" />
        </UButton>

        <template #body>
            <div class="space-y-3">
                <p>{{ tt('sdp.auctionInfoModal.description') }}</p>
                <UPageFeature v-for="(feature, index) in features" v-bind="feature" :key="index" />
            </div>
        </template>
    </UModal>
</template>
